import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/email.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2c4e78df")

_pushScopeId("data-v-2c4e78df")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"float":"right","padding-right":"32px"} }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "logo",
    width: "300"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", null, "Two Factor Authentication", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "A verification code has been sent to your email", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "This code will be valid for 15 minutes.", -1)
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"15px"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" VERIFY ")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { style: {"color":"lightslategray"} }, " Didn't receive the verification code email? ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Resend email ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  style: {"margin-top":"15px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" VERIFY ")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { style: {"color":"lightslategray"} }, " Didn't receive the verification code email? ", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Resend email ")
const _hoisted_15 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withId(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 18 }, {
          default: _withId(() => [
            _hoisted_3,
            _hoisted_4,
            _hoisted_5,
            (_ctx.formDataSignIn)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode(_component_el_form, {
                    model: _ctx.formDataSignIn,
                    rules: _ctx.rules,
                    ref: _ctx.refForm,
                    onSubmit: _withModifiers(_ctx.submitForm, ["prevent"])
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { prop: "verifyHash" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "Please enter the code here",
                            modelValue: _ctx.formDataSignIn.verifyHash,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formDataSignIn.verifyHash = $event)),
                            class: "input-with-select",
                            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitForm(_ctx.formDataSignIn)), ["enter"]))
                          }, {
                            append: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.formDataSignIn)), ["prevent"]))
                              }, {
                                default: _withId(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "onSubmit"]),
                  _hoisted_8,
                  _createVNode(_component_el_button, {
                    size: "small",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resendEmail(_ctx.formDataSignIn))),
                    disabled: _ctx.disableResend,
                    type: "text"
                  }, {
                    default: _withId(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.disableResend)
                    ? (_openBlock(), _createBlock("span", _hoisted_10, " ( " + _toDisplayString(_ctx.timeLeft) + "s )", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.formDataSignUp)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  _createVNode(_component_el_form, {
                    model: _ctx.formDataSignUp,
                    rules: _ctx.rules,
                    ref: _ctx.refForm,
                    onSubmit: _withModifiers(_ctx.submitForm, ["prevent"])
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { prop: "verifyHash" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "Please enter the code here",
                            modelValue: _ctx.formDataSignUp.verifyHash,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formDataSignUp.verifyHash = $event)),
                            class: "input-with-select",
                            onKeyup: _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.submitForm(_ctx.formDataSignUp)), ["enter"]))
                          }, {
                            append: _withId(() => [
                              _createVNode(_component_el_button, {
                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.formDataSignUp)), ["prevent"]))
                              }, {
                                default: _withId(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "onSubmit"]),
                  _hoisted_13,
                  _createVNode(_component_el_button, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resendEmail(_ctx.formDataSignUp))),
                    disabled: _ctx.disableResend,
                    type: "text"
                  }, {
                    default: _withId(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.disableResend)
                    ? (_openBlock(), _createBlock("span", _hoisted_15, " ( " + _toDisplayString(_ctx.timeLeft) + "s )", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})